webpackJsonp([23,35],{

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(7);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = new _vue2.default();

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(5),
	  /* template */
	  __webpack_require__(6),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventbus = __webpack_require__(2);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'btn',
	  props: {
	    name: {
	      type: String,
	      default: ''
	    },
	    theme: {
	      type: String,
	      default: 'default'
	    },
	    size: {
	      type: String,
	      default: 'default'
	    },
	    block: {
	      type: Boolean,
	      default: false
	    },
	    icon: {
	      type: String,
	      default: ''
	    },
	    disable: {
	      type: Boolean,
	      default: true
	    },
	    loading: {
	      type: Boolean,
	      default: false
	    },
	    submit: {
	      type: String,
	      default: ''
	    }
	  },
	  methods: {
	    handleClick: function handleClick() {
	      if (this.submit !== '') {
	        _eventbus2.default.$emit('btn-submit', this.submit);
	      }
	      if (this.disable && !this.loading) {
	        this.$emit('on-click', '');
	      }
	    }
	  },
	  data: function data() {
	    return {};
	  }
	};

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "btn",
	    class: [
	      'btn-' + _vm.theme,
	      'btn-' + _vm.size,
	      _vm.block ? 'btn-block' : ''
	    ],
	    on: {
	      "click": _vm.handleClick
	    }
	  }, [(_vm.icon != '' && !_vm.loading) ? _c('i', {
	    staticClass: "icon iconfont",
	    class: [_vm.icon ? 'icon-' + _vm.icon : '']
	  }) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('i', {
	    staticClass: "icon iconfont icon-loading loading"
	  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.name))])])
	},staticRenderFns: []}

/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(127),
	  /* template */
	  __webpack_require__(274),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _menusHorizon = __webpack_require__(50);
	
	var _menusHorizon2 = _interopRequireDefault(_menusHorizon);
	
	var _btn = __webpack_require__(4);
	
	var _btn2 = _interopRequireDefault(_btn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'menudemo',
	  components: {
	    menusHorizon: _menusHorizon2.default,
	    menusHorizonItem: _menusHorizon2.default.item,
	    btn: _btn2.default
	  },
	  methods: {
	    handleclick: function handleclick(item) {
	      this.content = item.alias;
	    }
	  },
	  data: function data() {
	    return {
	      content: 'like'
	    };
	  }
	};

/***/ }),

/***/ 274:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {}, [_c('div', {
	    staticClass: "m2000",
	    staticStyle: {
	      "background": "#fff"
	    }
	  }, [_c('menus-horizon', {
	    attrs: {
	      "size": "sm",
	      "current": _vm.content,
	      "surface": [{
	        icon: 'like',
	        currentIcon: 'likefill',
	        alias: 'like',
	        title: '收 藏'
	      }, {
	        icon: 'time',
	        currentIcon: 'timefill',
	        alias: 'time',
	        title: '时光机'
	      }, {
	        icon: 'shop',
	        currentIcon: 'shopfill',
	        alias: 'shop',
	        title: '小 摊'
	      }]
	    },
	    on: {
	      "on-click": _vm.handleclick
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "m2000",
	    staticStyle: {
	      "background": "#fff"
	    }
	  }, [_c('menus-horizon', {
	    attrs: {
	      "size": "sm"
	    }
	  }, [_c('menus-horizon-item', {
	    attrs: {
	      "alias": "like",
	      "icon": "like",
	      "current-icon": "likefill",
	      "title": "收 藏",
	      "tip": 0,
	      "current": _vm.content == 'like'
	    },
	    on: {
	      "on-click": _vm.handleclick
	    }
	  }), _vm._v(" "), _c('menus-horizon-item', {
	    attrs: {
	      "alias": "time",
	      "icon": "time",
	      "current-icon": "timefill",
	      "title": "时光机",
	      "tip": 0,
	      "current": _vm.content == 'time'
	    },
	    on: {
	      "on-click": _vm.handleclick
	    }
	  })], 1)], 1), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "font-size": "34px",
	      "padding-top": "30px",
	      "color": "#999"
	    }
	  }, [_vm._v("\n    " + _vm._s(_vm.content) + "\n  ")])])
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/23.5a9fb78b5fa58590e105.js